import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 岗位列表
 * @param params
 * 
*/

export const postList = params => Http.get(`${baseUrl}/post`, { params })
